"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isObject = isObject;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
 * Provides deep object merging of N objects
 *
 * @module core-merge
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */

/**
 * Tests if the passed in variable is an object or not
 *
 * @param {*} item
 * @return {*|boolean} true if the item is an object, false otherwise
 */
function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
}

/**
 * Does a deep merge of the source object into the target object
 *
 * @param {object} target The target object to merge in to
 * @param {object} source The source object to merge into the target
 */
function mergeObjects(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key) && isObject(source[key])) {
      if (!target[key]) {
        Object.assign(target, _defineProperty({}, key, {}));
      }
      merge(target[key], source[key]);
    } else {
      Object.assign(target, _defineProperty({}, key, source[key]));
    }
  }
}

/**
 * Does a deep merge of all provided source objects into the target object
 *
 * @param {*} target The target to merge in to
 * @param {*} sources The sources to merge into the target
 * @return {object} the merged target object
 */
function merge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) {
    return target;
  }
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    mergeObjects(target, source);
  }
  return merge.apply(void 0, [target].concat(sources));
}
var _default = exports["default"] = {
  merge: merge
};
//# sourceMappingURL=index.js.map